<template>
  <v-dialog
      v-model="dialog"
      persistent
      :close-on-back="false"
      transition="dialog-top-transition"
  >
    <v-card rounded="0">
      <v-card-text class="fw-700 fs-24">
        {{ message }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text>
        {{ computedContext }}
      </v-card-text>

      <v-card-actions class="mx-4 mb-4">
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-btn
                class="w-100"
                color="primary-light"
                rounded="0"
                size="large"
                variant="flat"
                @click="confirm(false)"
            >
              {{ translation(translationList.no, 'Începe de la zero') }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-btn
                class="w-100"
                color="primary"
                rounded="0"
                size="large"
                variant="flat"
                @click="confirm(true)"
            >
              {{ translation(translationList.yes, 'Completează automat') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {defineComponent, ref, computed, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {TranslationList} from '~/types/Utils';

export default defineComponent({
  name: 'ConfirmationDialog',
  props: {
    identifier: {
      type: String as PropType<string>,
      required: false,
    },
    message: {
      type: String as PropType<string>,
      required: true,
    },
    context: {
      type: String as PropType<string>,
      required: false,
    },
    showDialog: {
      type: Boolean,
      required: true,
    }
  },
  setup(props, {emit}) {
    const dialog = ref(props.showDialog);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const confirm = (response: boolean) => {
      emit('response', {response, identifier: props.identifier});
      dialog.value = false;
    };

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    const computedContext = computed(() => {
      return !props.context ? 'Am găsit o sesiune anterioară cu datele tale. Vrei să completăm automat informațiile pe care le-ai introdus anterior?' : props.context;
    });

    return {
      dialog,
      confirm,
      translationList,
      translation,
      computedContext
    };
  },
  watch: {
    showDialog(newValue) {
      this.dialog = newValue;
    }
  }
});
</script>

<style scoped>
</style>